import { GUID } from "./../../../../../../framework/domain-entity/guid";

class MortgageFireHongKongSettings {
  wpbProductId = new GUID("3840D5AA-7FB6-416A-9E3E-9D346562E648");
  cmbProductId = new GUID("AAEA26B4-812F-4FA1-AC43-7177EA129917");
}

export const mortgageFireHongKongSettings: MortgageFireHongKongSettings =
  new MortgageFireHongKongSettings();
